import { render, staticRenderFns } from "./ModalNoteInfoMap.vue?vue&type=template&id=06f4e10c&scoped=true"
import script from "./ModalNoteInfoMap.vue?vue&type=script&lang=ts"
export * from "./ModalNoteInfoMap.vue?vue&type=script&lang=ts"
import style0 from "./ModalNoteInfoMap.vue?vue&type=style&index=0&id=06f4e10c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4e10c",
  null
  
)

export default component.exports